export enum DocStatusType {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
}
